import {
  FinlandCommunicationAssetLevelEnum,
  FinlandCommunicationDirectionEnum,
  FinlandCommunicationProtocolTypeEnum,
  FinlandCommunicationServiceOperatorEnum,
} from "../globalEnums";

export const FinlandCommunicationProtocolTypeColorMapping: Record<FinlandCommunicationProtocolTypeEnum, string> = {
  [FinlandCommunicationProtocolTypeEnum.MODBUS]: "#C8E6C9", // Pastel Green
  [FinlandCommunicationProtocolTypeEnum.C104]: "#FFCDD2", // Pastel Red
  [FinlandCommunicationProtocolTypeEnum.ICCP]: "#FFF9C4", // Pastel Light Yellow
};

export const FinlandCommunicationServiceOperatorColorMapping: Record<FinlandCommunicationServiceOperatorEnum, string> =
  {
    [FinlandCommunicationServiceOperatorEnum.DSO]: "#FFE0B2", // Pastel Peach
    [FinlandCommunicationServiceOperatorEnum.TSO]: "#BBDEFB", // Pastel light blue
  };

export const FinlandCommunicationAssetLevelColorMapping: Record<FinlandCommunicationAssetLevelEnum, string> = {
  [FinlandCommunicationAssetLevelEnum.SITE]: "#D1C4E9", // Pastel Lavender
  [FinlandCommunicationAssetLevelEnum.PARC]: "#B2EBF2", // Pastel Cyan
  [FinlandCommunicationAssetLevelEnum.PROVIDING_ENTITY]: "#A0D2FF", // Pastel Star Command Blue
};

export const FinlandCommunicationDirectionColorMapping: Record<FinlandCommunicationDirectionEnum, string> = {
  [FinlandCommunicationDirectionEnum.SENT]: "#76d7c4", // Soft turquoise
  [FinlandCommunicationDirectionEnum.RECEIVED]: "#FFECB3", // Pastel Amber
};
